<div
  cdkDrag
  class="rfq-drag"
  (cdkDragStarted)="dragStart()"
  (cdkDragEnded)="dragEnd()"
  [ngStyle]="{ 'top.px': windowTop, 'left.px': windowLeft }"
>
  <div class="drag-preview" *cdkDragPreview matchSize></div>
  <div class="rfq-container-content" id="content">
    <div
      class="rfq-container-content__menu-bar"
      cdkDragHandle
      (mousedown)="updateZIndex()"
    >
      <div class="rfq-container-content__menu-bar__title">
        RFQ {{ tabIndex + 1 }}:&nbsp;
        <ng-container *ngTemplateOutlet="tabtitle"></ng-container>
        <div
          class="rfq-container-content__menu-bar__title__tabs-blocked"
          *ngIf="isRfqTabsBlocked"
        >
          - Close and press green refresh button to continue
        </div>
      </div>
      <!-- DISABLED for now *ngIf="canCloseWindow" -->
      <button
        class="rfq-container-content__menu-bar--right-button-close"
        (click)="maybeCloseWindow()"
      ></button>
    </div>

    <div class="rfq-container-content__main scrollable-content">
      <div
        class="rfq-container resize-able"
        #rfqContainer
        appResizerVertical
        (onResizeEmit)="autoResize = false"
        [minHeight]="minHeight"
      >
        <section role="tabpanel">
          <app-rfq-tab
            (toContainerCommunicator)="containerTabCommunication($event)"
            [tabData]="tab"
            [parentTabIndex]="tabIndex"
            (saveDimensions)="setStartingDimensions($event)"
            (resetRfqContainerHeight)="resetContainerHeight()"
          ></app-rfq-tab>
        </section>
      </div>
    </div>
  </div>
</div>

<ng-template #tabtitle>
  <span class="tab-button">
    {{ tab.title.quotePair?.base }}{{ tab.title.quotePair?.term }}
    <span>&nbsp;|&nbsp;</span>
    {{ tab.productLongNameToUse || tab.title.productName?.longName }}
    <span>&nbsp;|&nbsp;</span> {{ tabTitle() }}
    @if (tab.title.status.statusType) {
      <span
        [@tabStatus]="tab.title.status.statusType"
        class="tab-button__status-type"
        [ngClass]="tab.title.status.statusType"
      >
        <span>&nbsp;|&nbsp;</span>{{ tab.title.status.statusType }}
      </span>
    }

    @if (tab.title.status.statusExtra) {
      <span
        class="tab-button__extra-results"
        [ngClass]="tab.title.status.statusExtra | countDownColorClass"
      >
        <span>&nbsp;|&nbsp;</span
        >{{ tab.title.status.statusExtra | secondsToMinutes }}
      </span>
    }
  </span>
</ng-template>

@if (dialog.messages.length) {
  <app-rfq-dialog
    [header]="dialog.header"
    [messages]="dialog.messages"
    [onConfirm]="dialog.onConfirm"
    (onConfirmClick)="onDialogConfirm()"
    (onCancel)="onDialogCancel()"
  ></app-rfq-dialog>
}
